import { onUserAction } from '@studybay/common-client-library/seo-tricks';
import initHeader from '../_modules/new_header/header';

const faqBlocks = document.querySelectorAll('.faq-block');
const showZendeskBtn = document.getElementById('showZendesk');

initHeader()

faqBlocks.forEach(faqBlock => {
    const controller = faqBlock.querySelector('.faq-block__controller');

    controller.addEventListener('click', () => {
        const button = controller.querySelector('.faq-block__expander');
        const content = faqBlock.querySelector('.faq-block__content');

        const shouldShowContent = button.getAttribute('aria-expanded') === 'false';

        button.setAttribute('aria-expanded', shouldShowContent);
        if (shouldShowContent) content.removeAttribute('hidden');
        else content.setAttribute('hidden', true);

        button.focus();
    });
})

const hideFaqBlockContent = () => {
    faqBlocks.forEach(faqBlock => {
        const content = faqBlock.querySelector('.faq-block__content');
        content.setAttribute('hidden', true);
    })
}

onUserAction(hideFaqBlockContent);

initializeZendesk();

function initializeZendesk() {
    const s = document.createElement('script');
    s.id = 'ze-snippet';
    s.src = 'https://static.zdassets.com/ekr/snippet.js?key=956bfb04-09fe-4b23-bf72-8ac308148328';

    function init() {
        zE(() => {
            zE.setLocale('pt-BR');
            zE.hide();
            showZendeskBtn.addEventListener('click', () => zE.activate({ hideOnClose: true }));
        });
    }

    if (s.attachEvent) {
        s.attachEvent('onload', init);
    } else {
        s.addEventListener('load', init, false);
    }
    setTimeout(() => {
        document.body.appendChild(s);
    }, 5000);
}
